unable to read source [project]/node_modules/posthog-js/react/src/components/internal/VisibilityAndClickTrackers.tsx